// extracted by mini-css-extract-plugin
export default {"componentWrapper":"FileUploader_componentWrapper__2DupY","button":"FileUploader_button__iI+SZ","label":"FileUploader_label__6VOsw","file":"FileUploader_file__M8yP9"};